import * as React from "react";
import {
  InputElementUnion,
  IDateInputElement,
  DateInputFormType,
} from "@graffer-inc/form-schema";
import { CommonPropertiesEditor } from "../common-properties-editor";
import { useFormEditorContext } from "@graffer-inc/form-builder";
import { DateInputValidationEditor } from "./date-input-validation-editor";

type DateInputEditorProps = {
  element: IDateInputElement;
  onElementUpdate: (arg: InputElementUnion) => void;
};

export const DateInputEditor: React.FC<DateInputEditorProps> = ({
  element,
  onElementUpdate,
}) => {
  const { supportAllowedTermValidationForDateInput } = useFormEditorContext();
  const formTypeLabel: string = new DateInputFormType(
    element.formType,
  ).matchType({
    DatePicker: "カレンダー入力",
    MultiInput: "数値直接入力",
    SelectInput: "選択入力",
  });

  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      <div className="field">
        <label className="label">入力フォームタイプ</label>
        <div className="control">
          <p>{formTypeLabel}</p>
        </div>
      </div>
      {supportAllowedTermValidationForDateInput && (
        <>
          <hr />
          <DateInputValidationEditor element={element} />
        </>
      )}
    </>
  );
};
